import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'auditSpecialAction'
})
export class AuditSpecialActionPipe implements PipeTransform {

  transform(value: null | 0 | 1 | 2 | 3): string {
    switch (value) {
      case 1:
        return 'Neu erzeugt';

      case 2:
        return 'Gelöscht';

      case 3:
        return 'Bearbeitet & Abgeschlossen';

      default:
        return 'Bearbeitet';
    }
  }

}
